export default "__VITE_ASSET__a7d13216__"